<div class="d-none d-md-flex flex-column">
  <ng-container *ngTemplateOutlet="head" />
</div>

<ds-card class="card flex-column mt-md-4">
  <div class="d-flex flex-column d-md-none p-4 p-md-6 w-100 title">
    <ng-container *ngTemplateOutlet="head" />
  </div>

  <div class="d-flex flex-column flex-md-row">
    <div class="p-4 p-md-6 flex-1">
      <div class="mb-4 mb-md-6">
        <logos-container [flightItineraries]="option.flightItineraries" />
      </div>

      @for (itinerary of option.flightItineraries; let last = $last; track itinerary) {
        @if (itinerary.segments.length) {
          <option-itinerary
            [itinerary]="itinerary"
            [ngClass]="{ 'mb-3 mb-md-4': !last }"
            class="itinerary"
          />
        }
      }
    </div>

    <div class="p-4 p-md-6 d-flex flex-md-column align-items-center prices g-2">
      <div class="d-flex flex-column">
        @let soldAmount = getOptionSoldAmount(option);

        <save-badge
          *ngIf="(option.savePrice || 0) > 0 && soldAmount > 0"
          [amount]="option.savePrice"
          data-id="save-price"
          class="mb-2 mx-md-auto"
        />

        <cashback-badge
          *ngIf="option.cashback?.eligible"
          [amount]="option.cashback.amount"
          data-id="cashback"
          class="mb-2 mx-md-auto"
        />

        <div class="d-flex flex-md-column-reverse align-items-center mt-md-3">
          <h3 class="semi-bold sold-amount">
            <ng-container *ngTemplateOutlet="soldAmountTemplate" />
          </h3>

          <p
            *ngIf="option.onlinePrice > 0"
            class="ml-2 text-sun-crete-800 text-through online-price"
            data-id="online-price"
          >
            <span [innerHTML]="option.onlinePrice | portalCurrency"></span>
          </p>
        </div>

        <div
          *ngIf="option.totalPassengers; else defaultTemplate"
          class="d-flex align-items-center justify-content-md-center mb-md-3"
        >
          @if (option.isChange) {
            <p class="caption per-adult">Price difference per adult</p>
          } @else {
            <p class="caption per-adult">Per adult</p>
          }
          <img
            [tooltip]="pricesTooltip"
            [modal]="pricesTooltip"
            src="assets/icons/info_outlined.svg"
            width="16"
            height="16"
            alt="info"
            class="ml-1"
            data-id="prices"
          />
        </div>
      </div>

      <div class="d-flex ml-auto ml-md-0 mt-md-4 button-container">
        @switch (option.bookingStatus) {
          @case (PortalBookingStatusTypeEnum.Option) {
            <ds-button
              class="d-md-none"
              size="s"
              (click)="$event.stopPropagation(); requestToBook.emit()"
              [label]="isPresentation ? 'Continue to booking' : 'View flight details'"
              [disabled]="isSubmitting"
              data-id="request-to-book"
            />
            <ds-button
              class="d-none d-md-flex"
              (click)="$event.stopPropagation(); requestToBook.emit()"
              [label]="isPresentation ? 'Continue to booking' : 'View flight details'"
              [disabled]="isSubmitting"
              data-id="request-to-book"
              id="submit-{{ option.portalLink }}"
            />
          }
          @case (PortalBookingStatusTypeEnum.Booked) {
            <booking-status [status]="PortalBookingStatusTypeEnum.Booked" />
          }
          @case (PortalBookingStatusTypeEnum.InProgress) {
            <booking-status [status]="PortalBookingStatusTypeEnum.InProgress" />
          }
          @case (PortalBookingStatusTypeEnum.Issued) {
            <booking-status [status]="PortalBookingStatusTypeEnum.Issued" />
          }
        }
      </div>
    </div>
  </div>
</ds-card>

<ng-template #head>
  <div class="d-flex align-items-center">
    <h3 class="semi-bold option-title" data-id="option-title">Option {{ option.alphaName }}</h3>

    <div class="d-none d-md-flex align-items-center ml-3 g-1">
      <ng-container *ngTemplateOutlet="badges" />
    </div>
  </div>

  <div *ngIf="option.portalDescription" class="d-flex align-items-top mt-2">
    <img src="/assets/icons/note.svg" alt="note" width="20" height="20" />
    <p data-id="option-description" class="ml-2">{{ option.portalDescription }}</p>
  </div>

  <div class="d-flex g-1 d-md-none align-items-center mt-2 hide-scrollbar badges">
    <ng-container *ngTemplateOutlet="badges" />
  </div>
</ng-template>

<ng-template #badges>
  @let serviceClasses = option.flightItineraries | extractServiceClasses;
  @if (serviceClasses.length) {
    <service-class-badge [serviceClasses]="serviceClasses" />
  }
  @if (isLeastExpensive) {
    <least-expensive-badge />
  }
  @if (option.hotelBookings && option.hotelBookings.length) {
    <hotel-bookings-badge />
  }
  @if (option.expertChoice) {
    <experts-choice-badge />
  }
  @if (option.fastest) {
    <fastest-option-badge />
  }
</ng-template>

<ng-template #pricesTooltip>
  <div class="px-4 px-md-0 py-10 py-md-0">
    <prices-tooltip [option]="option" />
  </div>
</ng-template>

<ng-template #defaultTemplate>
  <p class="ml-auto ml-md-0 text-jazlyn-700">
    {{
      option.bookingStatus === PortalBookingStatusTypeEnum.InProgress ||
      option.bookingStatus === PortalBookingStatusTypeEnum.Issued
        ? 'Trip total'
        : 'Per traveler'
    }}
  </p>
</ng-template>

<ng-template #soldAmountTemplate>
  @let soldAmount = getOptionSoldAmount(option);
  @let prefix = option.isChange && soldAmount > 0 ? '+' : '';
  <span
    [class.text-green-700]="!soldAmount && option.isChange"
    data-id="sold-amount"
    [innerHTML]="prefix + (soldAmount | portalCurrency)"
  ></span>
</ng-template>
